{
  "info": "Informasjon",
  "negative": "Feil",
  "notice": "Advarsel",
  "positive": "Vellykket"
}
